import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import TagIcon from "../../icons/TagIcon"
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Popper from "@material-ui/core/Popper";

export default function AppTagChipArrayBottom(props) {
	const classes = useStyles();
	let tt = props.tt /*.slice(2) */
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef(null);
	let { tags_q, tags, arrayTag, setArrayTag } = props

	const chechActiveTags = (id) => {
		if (arrayTag) {
			return arrayTag.some(el => +el.key === +id)
		}
	}

	function AdditionalView(data, label) {
		if (data === '...' || props.cart) {
			// alert(props.tt)
		} else {
			if (arrayTag.some(el => +el.key === +data)) {
				setArrayTag([...arrayTag.filter(el => +el.key !== +data)]);
			} else {
				setArrayTag(arrayTag.concat([{ key: +data, label: label }]))
			}
		}
	}

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === "Tab") {
			event.preventDefault();
			setOpen(false);
		}
	}

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef(open);
	React.useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [open]);

	return (
		<Grid
			item
			lg={12} md={12} sm={12}
			component="ul"
			className={clsx(classes.root, {
				[classes.topTagArray]: props.position === 'top',
				[classes.middleTagArray]: props.position === 'middle',
				[classes.bottomTagArray]: props.position === 'bottom',
			})}
			style={{ alignItems: 'center' }}
		>
			{props.icon === true
				?
				<Grid item style={{ height: 16, width: 16, marginRight: 4 }}>
					<TagIcon fill='#BCBBD0' />
				</Grid>
				:
				''
			}

			{props.position !== 'bottom'
				?
				props.tags && props.tags.length > 0 && props.tags.split(', ').map((data) => {
					return (
						<li className={classes.li}>
							<Chip
								// onClick={() => AdditionalView(data)}
								style={{ backgroundColor: '#F6F6FB' }}
								label={data}
								className={classes.chip}
							/>
						</li>
					);
				})
				:
				tags && tags.length > 0 && tags.split(',').map((data, ind) => {
					let data_q = ''
					if (tags_q && tags_q.split(',').length > 0 && tags_q.split(',')[ind] !== undefined) {
						data_q = tags_q.split(',')[ind].replace(`${data}#;`, '')
					}
					return (
						<li className={classes.li} key={'AppTagChipArrayBottomCard_' + data_q}>
							{
								data !== ' ...'
									?
									// ОБЫЧНЫЙ ЧИПС
									<Chip
										//isActive={chechActiveTags(data_q)} // FOR ARH если тру - то красим и можно навешать  deleteIconSmall
										deleteIconSmall={arrayTag && arrayTag.includes(data_q)}
										onClick={() => AdditionalView(data_q, data)}
										label={data}
										className={chechActiveTags(data_q) ? classes.activeChip : classes.chip}
									/>
									:
									<React.Fragment>
										{/* ЧИПС (...) */}
										<Chip
											//isActive={chechActiveTags(data_q)} // FOR ARH если тру - то красим и можно навешать  deleteIconSmall
											ref={anchorRef}
											aria-controls={open ? "menu-list-grow" : undefined}
											aria-haspopup="true"
											onClick={handleToggle}
											deleteIconSmall={arrayTag && arrayTag.includes(data_q)}
											// onClick={() => ''}
											label={data}
											className={chechActiveTags(data_q) ? classes.activeChip : classes.chip}
										/>
										<div className={classes.root}>
											<Popper
												open={open}
												anchorEl={anchorRef.current}
												role={undefined}
												transition
												disablePortal
												placement={'bottom-end'}
												style={{ zIndex: 999 }}
											>
												{({ TransitionProps, placement }) => (
													<Grow
														{...TransitionProps}
														style={{
															transformOrigin:
																placement === "bottom" ? "center top" : "center bottom"
														}}
													>
														<ClickAwayListener onClickAway={handleClose}>
															<Grid
																autoFocusItem={open}
																id="menu-list-grow"
																onKeyDown={handleListKeyDown}
																style={{ padding: '4px 0' }}
																className={classes.subchipcntr}
															>
																{tt && tt.length > 0 && tt.split(',').map((data, ind) => {
																	let data_q = '';
																	let indef = tags_q && tt ? (tags_q.split(',').length) - (tt.split(',').length) : '';

																	if (tags_q && tags_q.split(',').length > 0 && tags_q.split(',')[ind] !== undefined) {
																		data_q = tags_q.split(',')[ind + indef].replace(`${data}#;`, '')
																	}
																	return (
																		data !== ' '
																			?
																			<Chip
																				deleteIconSmall={arrayTag && arrayTag.includes(data_q)}
																				onClick={() => AdditionalView(data_q, data)}
																				label={data}
																				className={chechActiveTags(data_q) ? classes.activeChip : classes.chip}
																			/>
																			:
																			''
																	)
																})}
															</Grid>
														</ClickAwayListener>
													</Grow>
												)}
											</Popper>
										</div>
									</React.Fragment>
							}
						</li>
					);
				})
			}
		</Grid >
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		// justifyContent: 'center',
		flexWrap: 'wrap',
		listStyle: 'none',
		color: '#F00',
		justifyContent: 'start',
		padding: '0 12px'
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#F6F6FB',
		fontSize: 13,
		lineHeight: '16px',
		color: '#8987A2',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},

		'&:hover': {
			background: '#F6F6FB',
		},

		'&:focus': {
			background: '#F6F6FB',
		},
	},

	activeChip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#EB505E',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFFFFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},

		'&:hover': {
			background: '#EB505E',
		},

		'&:focus': {
			background: '#EB505E',
		},
	},

	subchipcntr: {
		'& > div': {
			margin: '0 4px'
		},

		'& > div:first-child': {
			margin: '0 4px 0 0'
		},

		'& > div:last-child': {
			margin: '0 0 0 4px'
		}
	},

	li: {
		margin: '0 3.5px',

		'&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
	},

	topTagArray: {
		padding: '0 0 8px 0 !important',
		justifyContent: 'flex-end',
	},

	middleTagArray: {
		padding: '0 12px !important',
	},

	bottomTagArray: {
		padding: '0 8px',
	}
}));